import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: "root"
})
export class HttpService {
  private apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private storage: StorageService,
  ) { }

  // private getHeaders(): HttpHeaders {
  //   const headers = new HttpHeaders({
  //     "Content-Type": "application/json",
  //     Accept: "application/json"
  //   });

  //   const token = localStorage.getItem("token");
  //   if (token) {
  //     headers.append("Authorization", `Bearer ${token}`);
  //   }

  //   return headers;
  // }

  private getHeadersX(): HttpHeaders {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "application/json, multipart/form-data"
    });

    const token = this.storage.getItem("token");
    if (token) {
      headers = headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  }

  private getHeaders(contentType: 'json' | 'form' = 'json'): HttpHeaders {
    let headers = new HttpHeaders({
      "Accept": "application/json, multipart/form-data"
    });

    if (contentType === 'json') {
      headers = headers.set("Content-Type", "application/json");
    } else {
      headers = headers.set("Content-Type", "multipart/form-data");
    }

    const token = this.storage.getItem("token");
    if (token) {
      // alert(JSON.stringify(token));
      // console.log('token',token)
      headers = headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  }


  get<T>(path: string, options?: any): Observable<any> {
    const fullUrl = `${this.apiUrl}/${path}`;
    return this.http
      .get<T>(fullUrl, { headers: this.getHeaders(), ...options })
      .pipe(catchError(error => this.handleError<T>(error)));
  }

  post<T>(path: string, data: any, options?: any): Observable<any> {
    const fullUrl = `${this.apiUrl}/${path}`;
    return this.http
      .post<T>(fullUrl, data, { headers: this.getHeaders(), ...options })
      .pipe(catchError(error => this.handleError<T>(error)));
  }

  postNoJSON<T>(path: string, data: any, options?: any): Observable<any> {
    const fullUrl = `${this.apiUrl}/${path}`;
    return this.http
      // .post<T>(fullUrl, data)
      .post<T>(fullUrl, data, { headers: this.getHeaders('form'), ...options })
      .pipe(catchError(error => this.handleError<T>(error)));
  }

  put<T>(path: string, data: any, options?: any): Observable<any> {
    const fullUrl = `${this.apiUrl}/${path}`;
    return this.http
      .put<T>(fullUrl, data, { headers: this.getHeaders(), ...options })
      .pipe(catchError(error => this.handleError<T>(error)));
  }

  patch<T>(path: string, data: any, options?: any): Observable<any> {
    const fullUrl = `${this.apiUrl}/${path}`;
    return this.http
      .patch<T>(fullUrl, data, { headers: this.getHeaders(), ...options })
      .pipe(catchError(error => this.handleError<T>(error)));
  }

  delete<T>(path: string, options?: any): Observable<any> {
    const fullUrl = `${this.apiUrl}/${path}`;
    return this.http
      .delete<T>(fullUrl, { headers: this.getHeaders(), ...options })
      .pipe(catchError(error => this.handleError<T>(error)));
  }

  private handleError<T>(error: HttpErrorResponse): Observable<never> {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      //console.error("An error occurred:", error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      //console.error(
      //   `Backend returned code ${error.status}, body was: ${error.error}`
      // );
    }

    // Return the original error response, so it can be handled in the component
    return throwError(() => error);
  }
}
